import { MouseEvent } from 'react';

// checks if the user has clicked on a link and returns that link or false
export const checkIfClickedOnLink = (e: MouseEvent) => {
  // @ts-ignore path usage
  const elements = e.nativeEvent.path;
  let currentElement;

  if(!elements) return false;

  while ((currentElement = elements.shift())) {
    // check if the node-text-root was reached
    if (currentElement.classList.contains('node-text-root')) return false;

    // check if the current element is a link
    const isLink = currentElement.nodeName == 'A';
    if (isLink) return currentElement;
  }

  return false;
};
